import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";

interface ActivityProps {
  activity: {
    id: number;
    name: string;
    duration: number;
    checked: boolean;
    startTime: string;
    endTime: string;
    ampm: string;
    isActive: boolean;
    onReady: boolean;
  };
  currentTime: Dayjs;
  showTitle: boolean;
  index: number;
  listType: string;
  onchangeChecked: (e: any, index: number) => void;
}

const Activity: React.FC<ActivityProps> = ({ activity, currentTime, showTitle, index, listType, onchangeChecked }: ActivityProps) => {
  // const [onReady, setOnReady] = useState<boolean>(true);

  // useEffect(() => {
  //   if (currentIndex && index < currentIndex) {
  //     setOnReady(false);
  //   }
  // }, [index, currentIndex]);

  const calculateProgress = () => {
    const start = dayjs().set('hour', parseInt(activity.startTime.split(':')[0])).set('minute', parseInt(activity.startTime.split(':')[1])).set('second', 0);
    const end = dayjs().set('hour', parseInt(activity.endTime.split(':')[0])).set('minute', parseInt(activity.endTime.split(':')[1])).set('second', 0);
    const total = end.diff(start); // 总时间，以毫秒为单位
    const elapsed = currentTime.diff(start, 'second'); // 已经过的时间，以毫秒为单位
    const progress = (elapsed / total) * 100000;
    return Math.min(Math.max(progress, 0), 100);
  };

  return (
    <div className={`timeTable-item${ listType === "timetable" && activity.isActive? " tti-active" : "" }${activity.onReady? " tti-ready" : ""}`}>
      {index !== 0 || showTitle? (
        <div className="timetable-desh"></div>
      ) : null}
      <div className="timetable-data">
        <div className="timetable-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            {/* <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
            <path d="M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"/>
          </svg>
        </div>
        <div className={`timetable-duration${listType === "checklist"? " for-checklist" : ""}`}>
          <div className={`time-t-title${listType === "checklist" && activity.checked? " timetable-on-check" : ""}`}>
            <span>{activity.name? activity.name : "未命名活動"}</span>
          </div>
          {listType === "timetable"? (
            <div className="time-t-progress">
              <span className="ttp-start">{activity.startTime}</span>
              <div className="ttp-progress-bar">
                <div className="ttp-pb-bg"></div>
                {activity.isActive? (
                  <div className="ttp-pb-width" style={{ width: `${calculateProgress()}%` }}></div>
                ) : null}
              </div>
              <span className="ttp-end">
                {activity.endTime} {activity.ampm}
                {activity.isActive || activity.onReady? (
                  <svg fill="none" viewBox="0 0 14 14" className="ttp-n-process">
                    <g clipPath="url(#clip0_742_75687)">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7 11.8125C9.65787 11.8125 11.8125 9.65787 11.8125 7C11.8125 4.34213 9.65787 2.1875 7 2.1875C4.34213 2.1875 2.1875 4.34213 2.1875 7C2.1875 9.65787 4.34213 11.8125 7 11.8125Z"></path>
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.0625 1.3125L1.3125 3.0625"></path>
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10.9375 1.3125L12.6875 3.0625"></path>
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7 3.9375V7H10.0625"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_742_75687">
                        <rect width="14" height="14" fill="currentColor"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg fill="none" viewBox="0 0 17 13" className="ttp-n-check">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M2.75 6.9L6.425 10.575L15 2"></path>
                  </svg>
                )}
              </span>
            </div>
          ) : null}
        </div>
        {listType === "checklist"? (
          <div className="timetable-check">
            <input
              id={`timetable-${activity.id}`}
              type="checkbox"
              onChange={(e: any) => onchangeChecked(e, index)}
              checked={activity.checked}
              hidden
            />
            <label htmlFor={`timetable-${activity.id}`}>
              {activity.checked? (
                <svg fill="none" viewBox="0 0 17 13" className="ttp-n-check">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M2.75 6.9L6.425 10.575L15 2"></path>
                </svg>
              ) : null}
            </label>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Activity;